import "./TextArea.css";
export default function TextArea({
  placeholder = "",
  inputPlaceholder,
  helpblock,
  onTextChange,
  onChange,
  answerID,
  id,
  errorMode,
  value = '',
  isParentSubQuestion = false,
  disabled=false
}) {
  return (
    <>
      {(placeholder || helpblock) && (
        <div className="textarea-placeholder-helpblock-container">
          {placeholder && <p className="textarea-placeholder">{placeholder}</p>}
          {helpblock && <p className="textarea-helpblock">{helpblock}</p>}
        </div>
      )}
      <textarea
        disabled={disabled}
        id={id}
        placeholder={inputPlaceholder}
        className={errorMode ? "textarea-error" : "textarea"}
        onChange={(event) => {
          if (event.target.value.length > 0) {
            onChange && onChange(answerID, event.target.value, true, "", "");
            onTextChange(answerID, event.target.value);
          } else {
            onChange && onChange(answerID, null, true, "", "");
            onTextChange(answerID, null);
          }
        }}
        value={value}
      />
    </>
  );
}
